

















































import Button from '../../core/components/Button.vue';
import SimpleTable from '../../core/components/SimpleTable.vue';
import SectionTitle from '../../core/components/SectionTitle.vue';
import { Component, Prop, Mixins, Vue, Watch, Emit } from 'vue-property-decorator';
import {
    Combobox,
    MultipleSelect
} from '../../core/components';
import {
    AuthStoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    StoreHelper,
    NotificationStoreHelper
} from '../../core/mixins';
import Loading from 'vue-loading-overlay';
import moment from 'moment';
import { BroadcastsTypes, Company, dateTypes, grayDisabled } from '../../core/models';
import { activeFormatter, ColorsList, formatDate, formattedDate, getCurrentTimestamp, getVehicleIconByAlertType, OptionalCompany } from '../../core/utils';
import { VehicleAlert, VehicleProperties } from '../models/Vehicle';
import { SettingsService } from '../api/SettingsService';
import ConfirmAction from '../../core/components/ConfirmAction.vue';

@Component({
    components: {
        Loading,
        Button,
        ConfirmAction
    }
})
export default class VehicleAlertsIcons extends Mixins(
    AuthStoreHelper,
    StoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    NotificationStoreHelper
) {
    @Prop({ default(){return []} }) vehicleAlerts: Array<VehicleAlert>;
    @Prop({ default(){return {}}}) vehicleProperties: VehicleProperties;
    @Prop({ default: ''}) vehicleDescription: string;
    @Prop({ default: false }) isVehicleDetail: boolean;
    @Prop({default: -1}) vehicleId: number;
    grayDisabled: string = grayDisabled;
    ack: boolean = false;
    visibleModalDeactivateAlerts: boolean = false;
    deactivateAlertsConfirmMessageBody: string = 'Se desactivarán TODAS las alertas para este vehículo'
    deactivateAlertsConfirmMessage: string = ''
    deactivatingAlerts: boolean = false;
    skyColor: string = ColorsList.skyblue;

    deactivateAction(){
        this.showModalDeactivateAlerts()
    }

    deactivateAlerts(){
        this.deactivatingAlerts  = true;
            let ids = [this.vehicleId];
            SettingsService.deactivateAlertsToVehicles(
                {
                    vehicle_ids: ids
                }
            ).then((res) => {
                 this.deactivatingAlerts  = false;
                 this.deactivateAlertsSuccess(ids, res.acknowledge_date);
                this.$_successPatchRecipients(res.message)
            }).catch((err) => {
                this.ack = false;
                this.deactivatingAlerts  = false;
                this.$_catchLoadingDialog({
                    response: err.response.data || {},
                    alternative_msg: 'No se pudieron desactivar las alertas'
                });
            })
    }

     getTooltipForAlert(alert: VehicleAlert){
        let tooltip = '';
        if(this.vehicleProperties['alerts_types']){
             let alertInfo = this.vehicleProperties['alerts_types'][alert.type];
            if(alert.active){
                tooltip += `Problema: ${alertInfo.error}`
                if(alert.reported_date !== null){
                    tooltip += `<br>Descubierto el día: ${formattedDate(alert.reported_date, true)}`
                }
                return tooltip
            }

            tooltip+= `Alerta inactiva (${alertInfo.name})`;
            if(alert.acknowledge_date !== null){
                tooltip += `<br>Fecha ACK: ${formattedDate(alert.acknowledge_date, true)}`
            }
            return tooltip
        }
       
    }

    get existsActiveAlerts(){
        return this.vehicleAlerts.filter(alert => alert.active).length > 0
    }

    getIconForAlert(alert:VehicleAlert){
        return getVehicleIconByAlertType(alert.type)
    }

    showModalDeactivateAlerts(){
        this.deactivateAlertsConfirmMessage = `${this.deactivateAlertsConfirmMessageBody}: <b>${this.vehicleDescription}</b> <br><br><b>A tener en cuenta:</b> Si alguna alerta se vuelve a repetir se volverá a activar<br><br>¿Está seguro que desea continuar?`
        this.visibilityDeactivateAlertsConfirmation(true)
    }

    closeDeactivateAlertsConfirmationDialog(confirm: boolean) {
        if (confirm) {
            this.deactivateAlerts();
        }
        this.ack = false;
        this.visibilityDeactivateAlertsConfirmation(false)
    }

    visibilityDeactivateAlertsConfirmation(value) {
        this.visibleModalDeactivateAlerts = value;
    }

    @Emit()
    deactivateAlertsSuccess(vehicleIds: number[], acknowledgeDate: string){}
}
